import { Component } from "@angular/core";
import { FieldType } from "@ngx-formly/core";

@Component({
  selector: "astrobin-formly-field-button",
  templateUrl: "./formly-field-button.component.html",
  styleUrls: ["./formly-field-button.component.scss"]
})
export class FormlyFieldButtonComponent extends FieldType {}
